import {useCallback, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {billingPlatformApi} from 'api';
import {ConfirmModal, DataWrapper} from 'components';
import {useApiData, useIsChangedTo} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.BILLING.SUBSCRIPTION.PAUSE_SCHEDULE_MODAL;

type Props = {
    open: boolean;
    hasScheduledChanges?: boolean;
    onClose: (success: boolean) => void;
}

export const ConfirmPauseModal: React.FC<Props> = ({open, hasScheduledChanges, onClose}) => {
    const {t} = useTranslation();
    const hasOpened = useIsChangedTo(open, true);

    const onPauseSuccess = useCallback(() => {
        onClose(true);
    }, [onClose]);

    const {send: pauseSubscription, reset, error, loading} = useApiData(billingPlatformApi.pauseSubscription, {
        onSuccess: onPauseSuccess
    });

    const handleClose = useCallback((confirm: boolean) => {
        if (confirm) {
            pauseSubscription();
        } else {
            onClose(false);
        }
    }, [pauseSubscription, onClose]);

    useEffect(() => {
        if (hasOpened) {
            reset();
        }
    }, [open, hasOpened, reset]);

    return (
        <ConfirmModal
            open={open}
            maxWidth='xs'
            fullWidth
            title={t(T_KEYS.TITLE)}
            okDisabled={loading}
            onClose={handleClose}
        >
            {/* TODO: design */}
            <DataWrapper isLoading={loading} isError={!!error} hideContentOnLoading={false}>
                <div className='tw-ts-h5'>{t(T_KEYS.MESSAGE)}</div>
                {hasScheduledChanges && <div className='tw-mt-4 tw-font-bold tw-text-warning'>{t(T_KEYS.SCHEDULED_CHANGES_WARNING)}</div>}
            </DataWrapper>
        </ConfirmModal>
    );
};